"use client";
import React, { useState, useEffect } from "react";
import Link from "next/link";

const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL;
interface CommonBannerProps {
  authorSlug: string;
  authorImageSrcSetWebp: string;
  authorImageSrcSet: string;
  authorImage: string;
  authorName: string;
  dateISO?: string;
  dateLabel: string;
  readTime: string;
  title: string;
  excerpt: string;
  facebookUrl?: string;
  twitterUrl?: string;
  title_slug?: string;
}
export default function CommonBanner({
  authorSlug,
  authorImageSrcSetWebp,
  authorImageSrcSet,
  authorImage,
  authorName,
  dateISO,
  dateLabel,
  readTime,
  title,
  excerpt,
  facebookUrl,
  twitterUrl,
  title_slug,
}: CommonBannerProps) {
  const [copied, setCopied] = useState(false);
  const SITE_URL = process.env.NEXT_PUBLIC_SITE_URL || "https://coinccinos.com"; // fallback URL

  const [fullUrl, setFullUrl] = useState("");

  useEffect(() => {
    // ✅ यहाँ सही logic है - SITE_URL + title_slug
    if (title_slug && SITE_URL) {
      const url = `${SITE_URL}/${title_slug}`.replace(/\/+/g, "/"); // duplicate slashes remove
      setFullUrl(url);
    }
  }, [title_slug, SITE_URL]);

  const handleCopyClick = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    if (typeof navigator !== "undefined" && navigator.clipboard) {
      try {
        await navigator.clipboard.writeText(fullUrl);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      } catch (err) {
        console.error("Failed to copy URL:", err);
        fallbackCopyText(fullUrl);
      }
    } else {
      fallbackCopyText(fullUrl);
    }
  };

  // fallback function
  const fallbackCopyText = (text: string) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  // Convert publishDate string to a Date object
  const formattedDate = dateLabel
    ? new Date(dateLabel).toLocaleString("en-US", {
      day: "2-digit",
      month: "short", // Feb, Mar, etc.
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true, // for AM/PM
    })
    : "";

  // const fullUrl = useFullUrl();
  // console.log("pathname", fullUrl);
  return (
    <React.Fragment>
      <div className="gh-container">
        <div className="post-head-content">
          <div className="post-head-content-container">
            <div className="post-head-meta">
              <div
                className="post-head-authors"
                style={{
                  fontFamily: "manrope, sans-serif",
                  fontSize: "18px",
                  fontWeight: 900,
                  color: "#fff",
                }}
              >
                <span
                  className="post-head-author-span"
                  style={{
                    fontFamily: "manrope, sans-serif",
                    fontSize: "16px",
                    fontWeight: 900,
                    color: "#fff",
                  }}
                >
                  By
                </span>
                <Link
                  href={`/${authorSlug}`}
                  className="post-head-author"
                >
                  <picture>
                    <source
                      srcSet={
                        authorImageSrcSet
                          ? `${API_BASE_URL}/${authorImageSrcSet}`
                          : `${API_BASE_URL}/assets/img/user.png`
                      }
                      sizes="36px"
                      type="image/webp"
                    />
                    <img
                      className="post-head-author-image"
                      srcSet={
                        authorImageSrcSet
                          ? `${API_BASE_URL}/${authorImageSrcSet}`
                          : `${API_BASE_URL}/assets/img/user.png`
                      }
                      sizes="36px"
                      src={
                        authorImage
                          ? `${API_BASE_URL}${authorImage}`
                          : `${API_BASE_URL}/assets/img/user.png`
                      }
                      alt={`${authorName} profile image`}
                      data-categories="unclassified"
                    />
                  </picture>
                  <span className="post-head-author-name">{authorName}</span>
                </Link>
              </div>

              <span
                className="post-head-date"
                style={{
                  fontFamily: "manrope, sans-serif",
                  fontSize: "16px",
                  fontWeight: 900,
                  color: "#fff",
                }}
              >
                <time dateTime={dateLabel}>{formattedDate}</time>
              </span>
              <span className="post-head-read-time">{readTime}</span>
            </div>

            <h1 className="post-page-title">{title}</h1>
            <p className="post-page-excerpt">{excerpt}</p>
          </div>
          <div className="post-head-share-block">
            <div className="share-block">
              {/* facebook */}
              <a
                className="share-btn share-btn-facebook"
                href={`https://www.facebook.com/sharer.php?u=${fullUrl}`}
                target="_blank"
                rel="noopener"
                aria-label="Share on Facebook"
              >
                <svg
                  width="26"
                  height="26"
                  viewBox="0 0 26 26"
                  fill="none"
                  xmlns="https://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.0003 2.1665C7.01708 2.1665 2.16699 7.01659 2.16699 12.9998C2.16699 18.4068 6.12874 22.8885 11.3082 23.7021V16.1307H8.55649V12.9998H11.3082V10.6133C11.3082 7.89842 12.9245 6.39909 15.3999 6.39909C16.5851 6.39909 17.8244 6.61034 17.8244 6.61034V9.27534H16.4594C15.1128 9.27534 14.6936 10.1106 14.6936 10.9675V12.9998H17.6977L17.2177 16.1307H14.6936V23.7021C19.8719 22.8896 23.8337 18.4057 23.8337 12.9998C23.8337 7.01659 18.9836 2.1665 13.0003 2.1665Z"
                    fill="white"
                  ></path>
                </svg>
              </a>

              {/* x */}
              <a
                className="share-btn"
                href={`https://x.com/intent/tweet?url=${fullUrl}&text=${encodeURIComponent(title)}`}
                target="_blank"
                rel="noopener"
                aria-label="Share on X"
              >
                <svg
                  width="26"
                  height="26"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="https://www.w3.org/2000/svg"
                >
                  <g id="x new">
                    <path
                      id="Vector"
                      d="M18.5326 13.9627L28.4429 2.69632H26.0944L17.4894 12.4788L10.6165 2.69632H2.68945L13.0826 17.4891L2.68945 29.3037H5.03801L14.1252 18.9731L21.3835 29.3037H29.3105L18.532 13.9627H18.5326ZM15.3159 17.6195L14.2629 16.1464L5.88422 4.42537H9.49146L16.2531 13.8846L17.3062 15.3577L26.0956 27.6533H22.4883L15.3159 17.62V17.6195Z"
                      fill="white"
                    ></path>
                  </g>
                </svg>
              </a>

              {/* copy */}
              <button
                className={`share-btn copyToClipboardBtn ${copied ? "copied" : ""}`}
                type="button"
                onClick={handleCopyClick}
                title="Copy current page URL"
              >
                {copied ? "✓" : "🔗"}
              </button>
            </div>
          </div>
        </div>
      </div>

      {copied && (
        <div
          className="fixed top-4 right-4 bg-gray-900 text-white p-3 rounded-md shadow-lg z-9999 transition-transform transform opacity-0 animate-show"
          role="status"
        >
          Copied! This is my URL:
          <br />
          <small className="text-xs break-all opacity-90">{fullUrl}</small>
        </div>
      )}
    </React.Fragment>
  );
}
